import { Modal } from '@bbl-digital/snorre-v2'
import { useFileuploadPickerContext } from '../context/useFileuploadPickerContext'
import LocalFilePicker from '../LocalFilePicker/LocalFilePicker'
import { Step } from '../types/types'
import ArchiveFilePicker from '../ArchiveFilePicker/ArchiveFilePicker'

const FileuploadPickerModal = () => {
  const { showModal, onCloseModal, step } = useFileuploadPickerContext()

  return (
    <Modal
      className="overflow-y-hidden"
      open={!!showModal}
      onClose={onCloseModal}
    >
      {step === Step.LOCAL && <LocalFilePicker />}
      {step === Step.ARCHIVE && <ArchiveFilePicker />}
    </Modal>
  )
}

export default FileuploadPickerModal
